import { useEffect, useRef } from 'react';
import { UnitGpsDto } from '@mark43/cad-api';

export const useBulkGpsUpdate = (
    interval: number,
    bulkGpsUpdateCallback: (pendingGpsUpdate: Map<number, UnitGpsDto>) => void
) => {
    const bufferRef = useRef(new Map());

    useEffect(() => {
        const bulkGpsUpdate = () => {
            bulkGpsUpdateCallback(bufferRef.current);
            bufferRef.current = new Map();
        };

        const intervalId = setInterval(bulkGpsUpdate, interval);

        return () => {
            if (bufferRef.current.size > 0) {
                bulkGpsUpdate();
            }
            return clearInterval(intervalId);
        };
    }, [interval, bulkGpsUpdateCallback]);

    const addToBulkGpsUpdate = (gps: UnitGpsDto) => {
        bufferRef.current.set(gps.userId ?? gps.unitId, gps);
    };

    return { addToBulkGpsUpdate };
};
